import s from '../solution-rate-reviews.scss';
import React from 'react';
import StarFilled from 'wix-ui-icons-common/StarFilled';
import { LinearProgressBar, Heading, Box } from 'wix-style-react';
export var RateCharts = function (props) {
    var starsWithProgress = [5, 4, 3, 2, 1];
    return (React.createElement(Box, { direction: "vertical" }, starsWithProgress.map(function (swp) { return (React.createElement(StarsWithProgress, { key: swp, starsTofill: swp, reviewers: props["rating" + swp], barPrecentage: countAsPrecentage(props.totalCount, props["rating" + swp]) })); })));
};
var StarsWithProgress = function (_a) {
    var _b = _a.starsTofill, starsTofill = _b === void 0 ? 2 : _b, _c = _a.barPrecentage, barPrecentage = _c === void 0 ? 30 : _c, _d = _a.reviewers, reviewers = _d === void 0 ? 20 : _d;
    return (React.createElement("div", null,
        React.createElement(Box, { className: s.reviewersPerStars, verticalAlign: "middle" },
            React.createElement(FiveStars, { starsToFill: starsTofill }),
            React.createElement(LinearProgressBar, { value: barPrecentage || 0 }),
            React.createElement("div", { className: s.reviewCountPerStar },
                React.createElement(Heading, { appearance: "H6", className: s.reviewersPerStars, dataHook: "rating" + starsTofill }, reviewers)))));
};
export var FiveStars = function (_a) {
    var _b = _a.starsToFill, starsToFill = _b === void 0 ? 0 : _b, _c = _a.size, size = _c === void 0 ? 12 : _c;
    var stars = [1, 2, 3, 4, 5];
    return (React.createElement(Box, { className: s.chartsFiveStars }, stars.map(function (star, index) {
        return star <= starsToFill ? (React.createElement(StarFilled, { key: index, size: size.toString(), color: "#FDB10C" })) : (React.createElement(StarFilled, { size: size.toString(), key: index, color: "#E7EAEB" }));
    })));
};
var countAsPrecentage = function (totalCount, prartiaCount) {
    return (prartiaCount * 100) / totalCount;
};
//# sourceMappingURL=solution-rate-charts.js.map